
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"49","height":"49","viewBox":"0 0 49 49"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#F49A28","stroke-width":"3","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"stroke-linejoin":"round","d":"M24.5 38a.75.75 0 100 1.5.75.75 0 000-1.5h0"}}),_c('path',{attrs:{"d":"M24.5 32V17"}}),_c('path',{attrs:{"stroke-linejoin":"round","d":"M27.742 4.02a3.611 3.611 0 00-6.484 0L2.312 42.616A3.04 3.04 0 005.044 47h38.912a3.044 3.044 0 002.732-4.384L27.742 4.02z"}})])])
          )
        }
      }
    